import { Constructor } from 'vue-property-decorator'

export const QuestionComponentPluginSymbol = Symbol.for("QuestionComponentPluginSymbol");
export type QuestionComponentPlugin = Constructor

export const QuestionSolutionPluginSymbol = Symbol.for("QuestionSolutionPluginSymbol");
export type QuestionSolutionPlugin = Constructor

export type QuestionEvaluationResultType = 'not-evaluated' | 'correct' | 'partially-correct' | 'incorrect'

export type QuestionMode = 'practice' | 'exam'

export interface QuestionComponentProps2<TQuestion, TAnswer, TState> {
  question: Question<TQuestion>;
  mode?: QuestionMode;
  answer: Answer<TAnswer> | null;
  state: State<TState> | null;
  evaluated: boolean;
  evaluationResultType?: QuestionEvaluationResultType
  showSolution: boolean;
  showButtons?: boolean;
}

export interface QuestionEvaluationResult {
  type: QuestionEvaluationResultType
}

export interface QuestionComponent<TQuestion, TAnswer, TState, TCorrectAnswer = {}, TSolutionAnswer = TAnswer>
      extends QuestionComponentProps2<TQuestion, TAnswer, TState>
{
  emitAnswerChanged(answer: AnswerChangedPayload<TAnswer>): AnswerChangedPayload<TAnswer>
  emitStateChanged(answer: StateChangedPayload<TState>): StateChangedPayload<TState>
  emitSelfEvaluated?: () => void
  emitReset?: () => void
  solutionProps?: () => QuestionSolutionProps2<TSolutionAnswer, TCorrectAnswer>
}

export interface Question<T> {
  id: string
  content: T
}

export interface Answer<T> {
  answer: T
}

export interface State<T> {
  state: T
}

export interface QuestionSolutionProps2<TAnswer, TCorrectAnswer> {
  userAnswer: TAnswer;
  correctAnswer: TCorrectAnswer;
}

export interface AnswerChangedPayload<T> {
  answer: T
  score: number
}

export interface StateChangedPayload<T> {
  state: T
}
